module.exports = __webpack_public_path__ + "static/media/CopartYardPin.66ef384f.png";